import permissionService from "./services/permissions/permissions.service";
var currentToken = localStorage.getItem("token");
var currentUser = localStorage.getItem("user");
currentUser = currentUser ? JSON.parse(currentUser) : false;

export default {
	debug: true,
	state: {
		currentRoute: window.location.pathname,
		currentUser: currentUser ? currentUser : false,
		currentToken: currentToken ? currentToken : false
	},
	setUserData(userData) {
		const data = {
			...userData,
			module: permissionService.buildUserModuleObject(userData.permissions),
			permissions: permissionService.buildUserPermissionObject(
				userData.permissions
			)
		};
		localStorage.setItem("user", JSON.stringify(data));
		this.state.currentUser = data
	},
	setUserToken(token) {
		localStorage.setItem("token", token);
		this.state.currentToken = token;
	},
	setRoute(route, params = {}) {
		this.state.currentRoute = route;
		window.history.pushState(
			null,
			route,
			`${route}${this.paramsUrlStr(params)}`
		);
	},
	clearUser() {
		this.state.currentToken = false;
		this.state.currentUser = false;
		localStorage.removeItem("user");
		localStorage.removeItem("token");
	},
	paramsUrlStr(params = {}) {
		let str = "";
		for (let key in params) {
			if (str != "") {
				str += "&";
			}
			str += key + "=" + encodeURIComponent(params[key]);
		}
		return str != "" ? `?${str}` : "";
	}
};
